import { errorNotificationVar } from "@cache/cache";
import client from "@graphql/client";

import prepareTopicFileUploadMutation from "../graphql/prepare-topic-file-upload-mutation";

export const asyncUploadImageErrorMessage = "The image could not be uploaded.";

export type WysiwygUploadVariable = {
  topicId?: number;
  artifactId?: number;
  recognitionCoreValueId?: number;
  organizationId?: number;
};

export const asyncUploadImage = (uploadVariable: WysiwygUploadVariable) => {
  return (file: File) => {
    const p: Promise<string | undefined> = new Promise((resolve, reject) => {
      // we upload the image to S3 with presigned url
      // https://docs.aws.amazon.com/AmazonS3/latest/userguide/PresignedUrlUploadObject.html
      client
        .mutate({
          mutation: prepareTopicFileUploadMutation,
          variables: {
            filename: `${Date.now()}${file.name.substring(0, 100)}`,
            contentType: file.type,
            ...uploadVariable,
          },
        })
        .then(({ data }) => {
          const { fileUploadUrl, fileViewingUrl } = data.prepareFileUpload;
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = function (event: ProgressEvent<FileReader>) {
            if (event.target?.readyState !== FileReader.DONE) {
              return;
            }
            fetch(fileUploadUrl, {
              method: "PUT",
              headers: { "Content-Type": file.type },
              body: file,
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error(asyncUploadImageErrorMessage);
                }
                resolve(fileViewingUrl);
              })
              .catch(reject);
          };
        })
        .catch((e) => {
          errorNotificationVar({
            title: "The image could not be uploaded.",
            description: e.message,
          });
          reject(asyncUploadImageErrorMessage);
        });
    });
    return p;
  };
};
